import {
  FluentProvider,
  teamsLightTheme,
  teamsDarkTheme,
  teamsHighContrastTheme,
  Spinner
} from "@fluentui/react-components";
import { HashRouter as Router, Navigate, Route, Routes } from "react-router-dom";
import { useTeamsFx } from "@microsoft/teamsfx-react";
import Home from "./home-tab/home-tab";
import { TeamsFxContext } from "./app-context";
import config from "../config";
import { useEffect, useState } from "react";
import { initialState } from "../core/store/initial-state";
import { StateProvider, reducer } from "../core/store/state-context";
import { errorLoggingConstants } from "../utility/app-constants";
import { LogError } from "../utility/app-utilities";

/**
 * The main app component which handles the initialization and routing of the app.
 */
export default function App() {
  const [initialStore, setInitialStore] = useState({});
  const [appInitialization, setAppInitialization] = useState<boolean>(false);
  const { loading, theme, themeString, inTeams, context } = useTeamsFx({
    initiateLoginEndpoint: config.initiateLoginEndpoint!,
    clientId: config.clientId!,
  });

  const initiateApp = async () => {
    const storeValue = {
      ...initialState,
      inTeams,
      context,
      themeString,
      theme
    };

    setInitialStore({
      ...initialState,
      ...storeValue,
      inTeams,
      context,
      themeString,
      theme,
      hostConfig: {}
    });
    setAppInitialization(true);
  };


  useEffect(() => {
    if (context || process.env.BABEL_ENV === "test") {
      try {
        initiateApp();
      }
      catch (error) {
        const errorObject = {
          component: errorLoggingConstants.appComponentFile,
          method: errorLoggingConstants.useEffect,
          message: error as string,
          operation: errorLoggingConstants.initializeApp,
          params: {}
        };
        LogError(errorObject);
      }
    }
  }, [inTeams]);

  return (
    <TeamsFxContext.Provider value={{ theme, themeString }}>
      <FluentProvider
        theme={
          themeString === "dark"
            ? teamsDarkTheme
            : themeString === "contrast"
              ? teamsHighContrastTheme
              : {
                ...teamsLightTheme,
                colorNeutralBackground3: "#eeeeee",
              }
        }
      >
        <Router>
          {!appInitialization || loading ? (
            <Spinner style={{ margin: 100 }} />
          ) : (
            <StateProvider initialState={initialStore} reducer={reducer}>
              <Routes>
                <Route path="/home" element={<Home />} />
                <Route path="*" element={<Navigate to={"/home"} />}></Route>
              </Routes>
            </StateProvider>
          )}
        </Router>
      </FluentProvider>
    </TeamsFxContext.Provider>
  );
}
